const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '基本信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '潜在投标人',
        },
    },
    {
        component: 'ZlmTabDetail',
        options: {
            title: '投标人',
            data: [],
        },
    },
]

const dayjs = require('dayjs').default

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            this.$request.post(`/transformToAfter/app/track/zbggOverview`, {
                bdGuid: this.$route.query.id,
            }, { showLoading: true }).then((res) => {
                this.getQzTbrList(res.data).then((res2) => {
                    this.config[1].options.data = {
                        '标段名称': res.data.bdName,
                        '标段编号': res.data.bdBH,
                        '采购单位': res2.data.zbRName,
                        '项目经理': res2.data.projectManagerName,
                        '联系电话': res2.data.lianXiRenPhone,
                        '潜在投标人数': dayjs().valueOf() - res.data.kbTime < 0 ? this.getTbrs(res2?.data?.qzTbrCount) : res2?.data?.qzTbrCount,
                    }
                })
            })
        },
        getTbrs(num) {
            if (num >= 3) {
                return '大于等于三家'
            }
            return '小于三家'
        },
        getQzTbrList(obj) {
            return new Promise((resolve) => {
                this.$request.post(`/transformToAfter/app/bid/document/viewQianZaiTbr`, {
                    bdGuid: obj.bdGuid,
                }).then((res) => {
                    if (dayjs().valueOf() - obj.kbTime < 0) {
                        this.config.length = 2
                    } else if (res.data && res.data.potentialBidderList) {
                        this.config[3].options.data = res.data.potentialBidderList.map((t) => ({
                            '供应商名称': t.tbrName,
                            '联系人': t.lianXiRenName,
                            '联系电话': t.lianXiRenPhone,
                            'CA是否办理': t.isHandle,
                            'CA有效期（天）': t.expirationDate,
                            '保证金递交状态': t.isPayBaoZhengJin,
                            '成为潜在投标人时间': this.$util.timeFormatter(t.createTime),
                            '参与状态': t.status === 0 ? '撤销' : '正常',
                            '撤销参与时间': this.$util.timeFormatter(t.cheXiaoCanYuTime),
                            '弃标函附件': '',
                        }))
                    }
                    resolve(res)
                }).catch(() => {
                    resolve({ data: {}})
                })
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
